
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { patchPost } from '../../redux/features/posts/postsSlice';

export default function SingleGridItem({post}) {
    const dispatch = useDispatch()
    const {id, title, image, tags, createdAt, likes, isSaved} = post;

    // tags 
    let tagsView
    if(tags) tagsView = tags.map((tag , index)=>(
        index === (tags.length-1) ? <span key={tag}>#{tag}</span> : 
        <span key={tag}>#{tag},</span>))
    
    const likeHandler = ()=>{
        dispatch(patchPost({id, data: {likes: likes+1}}))
    }
    return (

        <div className="lws-card">
            <Link to={`post/${id}`}>
                <img src={image} className="lws-card-image" alt="" />
            </Link>
            <div className="p-4">
                <div className="lws-card-header">
                    <p className="lws-publishedDate">{createdAt}</p>
                    <p className="lws-likeCount" onClick={likeHandler}><i className="fa-regular fa-thumbs-up"></i>{likes}</p>
                </div>
                <Link to={`post/${id}`} className="lws-postTitle"> {title} </Link>
                <div className="lws-tags">{tagsView}</div>
                
                {isSaved &&
                <div className="flex gap-2 mt-4">
                    <span className={`lws-badge`}> Saved </span>
                </div>}
               
            </div>
        </div>

    )
};